/* eslint-disable react/prop-types */
import { useLocation, useNavigate } from 'react-router-dom';
import Wrong from '@assets/wrong.svg';
import { ErrorCode } from '@constants';
import { Note, SeelEmail, Button } from '@components';

const ErrorText = {
  [ErrorCode.Wrong]: 'Something went wrong, and your submission failed. \nPlease try again later. Should you have any questions, please contact us at',
  [ErrorCode.Expired]: 'Shipping Protection for this order has expired. No more issues can be reported. Should you have any questions, please contact us at',
  [ErrorCode.Total]: 'The total payout for this order has already reached the total value paid for the purchased item(s). No more issues can be reported. Should you have any questions, please contact us at',
  [ErrorCode.Refresh]: 'Session expired. Please log in again.',
  [ErrorCode.WrongRequest]: 'Something went wrong with this request. Please contact at',
  [ErrorCode.Cancelled]: 'Shipping Protection for this order has been canceled. No more issues can be reported. The cancellation is probably due to the cancellation of your order, or the merchant’s refund of your Shipping Protection fee. Should you have any questions, please contact us at',
  [ErrorCode.HasOldClaim]: "You've already submitted the issue. The issue is being processed or has already been processed. If you have any questions, please contact",
  [ErrorCode.CoverdItemEmpty]: 'Something went wrong with your cover. Please contact us at',
};

export const ErrorPage = ({ code }) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const errCode = state?.code || code || ErrorCode.Wrong;
  const backStep = state?.backStep;
  const backHome = () => navigate('/17track');

  if (errCode === ErrorCode.Refresh) {
    return (
      <Note
        icon={Wrong}
        title="Oops!"
        subTitle={ErrorText[errCode]}
        hasBackBtn={false}
      >
        <Button
          onClick={backHome}
          style={{
            background: '#fff',
            border: '1px solid #BABFC3',
            borderRadius: '2px',
            color: '#202223',
            padding: '8px 16px',
            boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05)',
          }}
        >
          Log in
        </Button>
      </Note>
    );
  }

  return (
    <Note
      icon={Wrong}
      title="Sorry"
      hasBackBtn
      backStep={backStep}
    >
      <section style={{ marginBottom: '24px' }}>
        <span>{ErrorText[errCode]}</span>
        <SeelEmail style={{ marginLeft: '8px' }} />
        <span>.</span>
      </section>
    </Note>
  );
};
